import * as React from "react";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import { IRecurlyCoupon } from "store/entities/recurly";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

interface IProps {
  nonViewersCount: number;
  expirationDate: string;
  isCanceled: boolean;
  coupon: IRecurlyCoupon | null;
}

export const PhasePaidNoCC: React.FC<IProps> = ({ nonViewersCount, expirationDate, isCanceled, coupon }) => (
  <>
    {isCanceled && (
      <Text customColor={withVar(DesignToken.ActionNegativeDefault)}>
        Your subscription will be canceled on <strong>{expirationDate}</strong>.
      </Text>
    )}
    {!isCanceled && (
      <Text customColor={withVar(DesignToken.ActionPositiveDefault)}>Subscription is up and running!</Text>
    )}
    {coupon && (
      <Text>
        The “<strong>{coupon.code}</strong>” coupon is still active.
      </Text>
    )}
    {!isCanceled && (
      <Text>
        Your account expires on <strong>{expirationDate}</strong>.
      </Text>
    )}
    <Text>
      You have{" "}
      <strong>
        {nonViewersCount} paid {plural(nonViewersCount, "user", "users")}
      </strong>{" "}
      in HelpDesk.
    </Text>
  </>
);
